import { Phone, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateVoicemailTranscriptionAndCallbackWithAiAr: TemplateAr = {
  name: 'أتمتة تفريغ البريد الصوتي والاتصال المرتجع بالذكاء الاصطناعي',
  description:
    'الـ AI يفرّغ كل رسالة صوتية ويصنّفها، وإما يحلها باتصال مرتجع أو يوصّلها للموظف المناسب خلال دقائق — مو أيام.',
  category: 'المكالمات الهاتفية بالذكاء الاصطناعي',
  workflow: [
    { icon: Phone, label: 'رسالة صوتية' },
    { icon: Sparkles, label: 'الـ AI يصنّف' },
    { icon: Phone, label: 'اتصال مرتجع', final: true },
  ],
  detailDescription: {
    paragraph1:
      'بريدك الصوتي مو صندوق مهمل. الـ AI يفرّغ الرسالة لحظياً، ويصنّف نيّتها حسب تصنيفاتك، ويقيّم درجة إلحاحها، ويقرر الخطوة اللي بعدها. الطلبات الروتينية (متابعة حالة، إعادة تعيين كلمة مرور، أسئلة شائعة بسيطة، جدولة مواعيد) يرجع لها الـ AI بمكالمة خلال ٦٠ ثانية. والعاجل أو الحسّاس ينبّه الموظف المناسب على Slack أو رسالة نصية، والتفريغ والنيّة مرفقين معه من أول لحظة.',
    paragraph2:
      'كل رسالة صوتية تنزل سجلاً منظّماً في CRM أو نظام الدعم عندك — الملف الصوتي، والتفريغ، والنيّة المكتشفة، والمشاعر، والإجراء المقترح، والنتيجة. والتحليلات تبيّن لك كم رسالة حلّها الـ AI مقابل اللي احتاجت تصعيداً، ومتوسط زمن المعالجة، ووش النوايا اللي تقدر تأتمتها بعدها. ومتعدد اللغات: أكثر من ١٠٠ لغة، تفريغ وتصنيف لكل وحدة.',
  },
  benefits: [
    'الرسالة الصوتية تنحل خلال دقائق، مو أيام',
    'الـ AI يرجع للطلب الروتيني بمكالمة في أقل من ٦٠ ثانية',
    'الـ AI يصعّد للبشر حسب درجة الإلحاح',
    'كل رسالة تنزل سجلاً منظّماً في CRM أو نظام الدعم عندك',
    'أكثر من ١٠٠ لغة، وتصنيف لكل وحدة',
    'تشوف نسبة الحل والتصعيد لكل نيّة',
  ],
};
